module.exports = __webpack_public_path__ + "static/media/OliverGibson.8248cfaf.jpg";